import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import Checkbox from '@mui/joy/Checkbox';
import Typography from '@mui/joy/Typography';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

interface ConfirmMoveBookingModalProps {
    open: boolean;
    bookingTitle: string;
    newDate: string;
    onConfirm: (notifyCustomer: boolean) => void;
    onCancel: () => void;
    isSubmitting?: boolean;
}

export default function ConfirmMoveBookingModal({
    open,
    bookingTitle,
    newDate,
    onConfirm,
    onCancel,
    isSubmitting = false,
}: ConfirmMoveBookingModalProps) {
    const [notifyCustomer, setNotifyCustomer] = useState(true);

    useEffect(() => {
        if (open) {
            setNotifyCustomer(true);
        }
    }, [open]);

    return (
        <Modal open={open} onClose={onCancel}>
            <ModalDialog
                variant="outlined"
                role="dialog"
                sx={{
                    width: { xs: '90vw', sm: 'auto' },
                    maxWidth: { xs: '90vw', sm: '460px' },
                }}
            >
                <DialogTitle>
                    <CalendarMonthRoundedIcon />
                    Confirm booking move
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <Typography level="body-md">
                        Move <strong>{bookingTitle || 'this booking'}</strong> to <strong>{newDate}</strong>?
                    </Typography>
                    <Checkbox
                        label="Notify customer"
                        checked={notifyCustomer}
                        onChange={(event) => setNotifyCustomer(event.target.checked)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="solid" onClick={() => onConfirm(notifyCustomer)} disabled={isSubmitting}>
                        {isSubmitting ? 'Saving...' : 'Confirm'}
                    </Button>
                    <Button variant="plain" color="neutral" onClick={onCancel} disabled={isSubmitting}>
                        Cancel
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    );
}
